export default "__VITE_ASSET__6b3efdf3__"